export default __webpack_public_path__ + "static/media/about-potrait.99746542.png";